import React, { useRef, useState } from "react";

import { css } from "@emotion/react";

import { CSS_MQ } from "../../../styles/breakpoints";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { fontSize } from "../../../styles/fonts";
import { ChevronDownSvg } from "../../HeaderComponent/subcomponents/ChevronDownSvg";

type OpenableContainerProps = React.PropsWithChildren<{
  label: React.ReactNode;
  IconComponent: React.FunctionComponent;
}>;

export const OpenableContainer: React.FC<OpenableContainerProps> = props => {
  const [isOpened, setOpened] = useState(false);
  const toggle = () => setOpened(_ => !_);

  return (
    <div className={isOpened ? "opened" : "closed"} css={wrapperStyles}>
      <div onClick={toggle} css={divStyles}>
        <props.IconComponent css={iconStyles} />

        <span className="u-uppercase" css={fontSize.x2s}>
          {props.label}
        </span>

        <ChevronDownSvg css={upArrowStyles} />
      </div>

      {props.children}
    </div>
  );
};

const wrapperStyles = css`
  ${CSS_MQ.atMostSm} {
    border: 1px solid ${CSS_COLORS.GrayDark2024};
    border-radius: 8px;
    width: 100%;
  }

  cursor: pointer;

  -webkit-tap-highlight-color: transparent;
`;

const divStyles = css`
  display: grid;
  align-items: center;
  grid-template-columns: 30px 1fr 19px;

  ${CSS_MQ.atMostSm} {
    padding: 15px 18px;
  }

  ${CSS_MQ.atLeastMd} {
    display: none;
  }
`;

const iconStyles = css`
  width: 24px;
  height: 24px;

  ${CSS_MQ.atLeastMd} {
    width: 100%;
    height: 100%;
  }

  margin-left: -5px; // align visually
  margin-right: 10px;
`;

const upArrowStyles = css`
  width: 32px;
  height: 28px;

  color: black;

  transition: transform 0.1s linear;
  .opened & {
    transform: rotate(-180deg);
  }
`;
